import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
export const usePersonaKYBStatus = function usePersonaKYBStatus() {
    let { enabled = true, refreshOnHookMount = false, withLoader = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const worksAt = useStore(selectors.user.business);
    const businessId = worksAt === null || worksAt === void 0 ? void 0 : worksAt.id;
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.PersonaKYBStatus,
            businessId
        ],
        queryFn: ()=>api.vendor.getKYBStatus(businessId),
        enabled: enabled && !!businessId,
        staleTime: 2000,
        refreshOnHookMount,
        withLoader
    });
    return {
        personaKYBStatus: data,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
